<template>
    <div>
    <b-row v-if="!success && !error">
      <b-col md="7" lg="5" class="mt-5 mx-auto">
        <b-form @submit.prevent="onSubmit" id="create-form">
          <div class="content">
            <h4>{{ labels.title }}</h4>
            <p>{{ labels.info }}</p>
          </div>
          <b-form-group :class="{ formLoading: isLoading }">
            <md-field>
              <md-select v-model="form.tipovinculacion" :placeholder="labels.tipovinculacion" required>
                <md-option value="es-ES">Empleado</md-option>
                <md-option value="en-US">Proveedor</md-option>
                <md-option value="en-US">Cliente</md-option>
                <md-option value="en-US">Tercero vinculado</md-option>
              </md-select>
            </md-field>
            <md-field class="custom-date-picker">
                <label>{{ labels.date }}</label>
                <!-- <date-picker
                    v-model="form.date"
                    :format="datePickerFormat"
                    :value-type="datePickerFormat"
                    :placeholder="labels.date"
                >
                </date-picker> -->
                <md-input
                    type="date"
                    name="date"
                    v-model="form.date"
                    :placeholder="labels.date"
                    required
                />
            </md-field>
            <div class="content">
                <h5>{{ labels.titleTipoPers }}</h5>
            </div>
            <div class="content row">
                <div class="col-6">
                    <b-button type="button" id="perNatural" @click="tpNatural">{{labels.btnNatural}} </b-button>
                </div>
                <div class="col-6">
                    <b-button type="button" id="perJuridica" @click="tpJuridica">{{labels.btnJuridica}} </b-button>
                </div>
            </div>
            <div class="content" v-if="showPersonaNatural">
                <h5 class="text-center mt-3">
                    Persona Natural
                </h5>
                <md-field>
                  <label>{{ labels.primerApellido }}</label>
                  <md-input
                    type="text"
                    name="primerApellido"
                    v-model="form.primerApellido"
                    :placeholder="labels.primerApellido"
                    required
                  />
                </md-field>
                <md-field>
                  <label>{{ labels.segundoApellido }}</label>
                  <md-input
                    type="text"
                    name="segundoApellido"
                    v-model="form.segundoApellido"
                    :placeholder="labels.segundoApellido"
                    required
                  />
                </md-field>
                <md-field>
                  <label>{{ labels.nombre }}</label>
                  <md-input
                    type="text"
                    name="nombre"
                    v-model="form.nombre"
                    :placeholder="labels.nombre"
                    required
                  />
                </md-field>
                <md-field>
                    <md-select v-model="form.identificacion" :placeholder="labels.identificacion" required>
                        <md-option value="cc">C.C.</md-option>
                        <md-option value="ti">T.I.</md-option>
                        <md-option value="ce">C.E.</md-option>
                        <md-option value="rc">R.C.</md-option>
                        <md-option value="ot">OTRO</md-option>
                    </md-select>
                </md-field>
                <md-field>
                  <label>{{ labels.nroIdentNat }}</label>
                  <md-input
                    type="number"
                    name="nroIdentNat"
                    v-model="form.nroIdentNat"
                    :placeholder="labels.nroIdentNat"
                    required
                  />
                </md-field>
                <md-field class="custom-date-picker">
                    <label>{{ labels.dateIssue }}</label>
                    <!-- <date-picker
                        v-model="form.dateIssue"
                        :format="datePickerFormat"
                        :value-type="datePickerFormat"
                        :placeholder="labels.dateIssue"
                    >
                    </date-picker> -->
                    <md-input
                        type="date"
                        name="dateIssue"
                        v-model="form.dateIssue"
                        :placeholder="labels.dateIssue"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.placeIssue }}</label>
                    <md-input
                        type="text"
                        name="placeIssue"
                        v-model="form.placeIssue"
                        :placeholder="labels.placeIssue"
                        required
                    />
                </md-field>
                <md-field class="custom-date-picker">
                    <label>{{ labels.dateBirthdate }}</label>
                    <!-- <date-picker
                        v-model="form.dateBirthdate"
                        :format="datePickerFormat"
                        :value-type="datePickerFormat"
                        :placeholder="labels.dateBirthdate"
                    >
                    </date-picker> -->
                    <md-input
                        type="date"
                        name="dateBirthdate"
                        v-model="form.dateBirthdate"
                        :placeholder="labels.dateBirthdate"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.nationality }}</label>
                    <md-input
                        type="text"
                        name="nationality"
                        v-model="form.nationality"
                        :placeholder="labels.nationality"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.occupation }}</label>
                    <md-input
                        type="text"
                        name="occupation"
                        v-model="form.occupation"
                        :placeholder="labels.occupation"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.profession }}</label>
                    <md-input
                        type="text"
                        name="profession"
                        v-model="form.profession"
                        :placeholder="labels.profession"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.econoActi }}</label>
                    <md-input
                        type="text"
                        name="econoActi"
                        v-model="form.econoActi"
                        :placeholder="labels.econoActi"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.direccion }}</label>
                    <md-input
                        type="text"
                        name="direccion"
                        v-model="form.direccion"
                        :placeholder="labels.direccion"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.ciudad }}</label>
                    <md-input
                        type="text"
                        name="ciudad"
                        v-model="form.ciudad"
                        :placeholder="labels.ciudad"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.telefono }}</label>
                    <md-input
                        type="number"
                        name="telefono"
                        v-model="form.telefono"
                        :placeholder="labels.telefono"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.email }}</label>
                    <md-input
                        type="email"
                        name="email"
                        v-model="form.email"
                        :placeholder="labels.email"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.ingresosMensuales }}</label>
                    <md-input
                        type="number"
                        name="ingresosMensuales"
                        v-model="form.ingresosMensuales"
                        :placeholder="labels.ingresosMensuales"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.egresosMensuales }}</label>
                    <md-input
                        type="number"
                        name="egresosMensuales"
                        v-model="form.egresosMensuales"
                        :placeholder="labels.egresosMensuales"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.activos }}</label>
                    <md-input
                        type="number"
                        name="activos"
                        v-model="form.activos"
                        :placeholder="labels.activos"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.pasivos }}</label>
                    <md-input
                        type="number"
                        name="pasivos"
                        v-model="form.pasivos"
                        :placeholder="labels.pasivos"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.otrosIngresos }}</label>
                    <md-input
                        type="number"
                        name="otrosIngresos"
                        v-model="form.otrosIngresos"
                        :placeholder="labels.otrosIngresos"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.conceptoOtrIngresos }}</label>
                    <md-input
                        type="text"
                        name="conceptoOtrIngresos"
                        v-model="form.conceptoOtrIngresos"
                        :placeholder="labels.conceptoOtrIngresos"
                        required
                    />
                </md-field>
            </div>
            <div class="content" v-if="showPersonaJuridica">
                <h5 class="text-center mt-3">
                    Persona Jurídica
                </h5>
                <md-field>
                    <label>{{ labels.razonSocial }}</label>
                    <md-input
                        type="text"
                        name="razonSocial"
                        v-model="form.juridica.razonSocial"
                        :placeholder="labels.razonSocial"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.representanteLegal }}</label>
                    <md-input
                        type="text"
                        name="representanteLegal"
                        v-model="form.juridica.representanteLegal"
                        :placeholder="labels.representanteLegal"
                        required
                    />
                </md-field>
                <md-field>
                    <md-select v-model="form.juridica.identificacion" :placeholder="labels.identificacion" required>
                        <md-option value="cc">C.C.</md-option>
                        <md-option value="ti">T.I.</md-option>
                        <md-option value="ce">C.E.</md-option>
                        <md-option value="rc">R.C.</md-option>
                        <md-option value="ot">OTRO</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ labels.nroIdentJur }}</label>
                    <md-input
                        type="number"
                        name="nroIdentJur"
                        v-model="form.juridica.nroIdentJur"
                        :placeholder="labels.nroIdentJur"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.placeIssue }}</label>
                    <md-input
                        type="text"
                        name="placeIssue"
                        v-model="form.juridica.placeIssue"
                        :placeholder="labels.placeIssue"
                        required
                    />
                </md-field>
                <md-field class="custom-date-picker">
                    <label>{{ labels.dateIssue }}</label>
                    <!-- <date-picker
                        v-model="form.juridica.dateIssue"
                        :format="datePickerFormat"
                        :value-type="datePickerFormat"
                        :placeholder="labels.dateIssue"
                    >
                    </date-picker> -->
                    <md-input
                        type="date"
                        name="dateIssue"
                        v-model="form.dateIssue"
                        :placeholder="labels.dateIssue"
                        required
                    />
                </md-field>
                <h5 class="text-center mt-5">
                    Datos oficina
                </h5>
                <md-field>
                    <label>{{ labels.direccionOfi }}</label>
                    <md-input
                        type="text"
                        name="direccionOfi"
                        v-model="form.juridica.direccionOfi"
                        :placeholder="labels.direccionOfi"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.ciudadOfi }}</label>
                    <md-input
                        type="text"
                        name="ciudadOfi"
                        v-model="form.juridica.ciudadOfi"
                        :placeholder="labels.ciudadOfi"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.telefonoOfi }}</label>
                    <md-input
                        type="number"
                        name="telefonoOfi"
                        v-model="form.juridica.telefonoOfi"
                        :placeholder="labels.telefonoOfi"
                        required
                    />
                </md-field>
                <md-field>
                    <label>Fax</label>
                    <md-input
                        type="text"
                        name="fax"
                        v-model="form.juridica.faxOfi"
                        :placeholder="Fax"
                        required
                    />
                </md-field>
                <h5 class="text-center mt-5">
                    Datos sucursal
                </h5>
                <md-field>
                    <label>{{ labels.direccionSuc }}</label>
                    <md-input
                        type="text"
                        name="direccionSuc"
                        v-model="form.juridica.direccionSuc"
                        :placeholder="labels.direccionSuc"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.ciudadSuc }}</label>
                    <md-input
                        type="text"
                        name="ciudadSuc"
                        v-model="form.juridica.ciudadSuc"
                        :placeholder="labels.ciudadSuc"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.telefonoSuc }}</label>
                    <md-input
                        type="number"
                        name="telefonoSuc"
                        v-model="form.juridica.telefonoSuc"
                        :placeholder="labels.telefonoSuc"
                        required
                    />
                </md-field>
                <md-field>
                    <label>Fax</label>
                    <md-input
                        type="text"
                        name="fax"
                        v-model="form.juridica.faxSuc"
                        :placeholder="Fax"
                        required
                    />
                </md-field>
                <md-field>
                    <label>{{ labels.email }}</label>
                    <md-input
                        type="email"
                        name="email"
                        v-model="form.email"
                        :placeholder="labels.email"
                        required
                    />
                </md-field>
            </div>
            <div class="content" v-if="showDeclaracion">
                <h5 class="text-center mt-5">
                    Declaración de origen y tratamiento de datos personales
                </h5>
                <p class="text-left mt-4">
                    1.La actividad, profesión u oficio es licita y se ejerce dentro del marco legal y los recursos de la misma no provienen de actividades ilicitas de las contempladas en el
                    Codigo Penal Colombiano.
                </p>
                    <label>
                        <input type="radio" value="si" v-model="decUno"> Sí
                    </label>  &nbsp; &nbsp;
                    <label>
                        <input type="radio" value="no" v-model="decUno"> No
                    </label>
                <p class="text-left mt-4">
                    2.La información que he suministrado en la solicitud y en este documento es veraz y verificable y me obligo a actualizarla anualmente.
                </p>
                    <label>
                        <input type="radio" value="si" v-model="decUno"> Sí
                    </label>  &nbsp; &nbsp;
                    <label>
                        <input type="radio" value="no" v-model="decUno"> No
                    </label>
                <p class="text-left mt-4">
                    3.Los recursos que se deriven del desarrollo de este contrato no se destinaran a la financiacion del terrorismo, grupo terrrorista o actividades terroristas.
                </p>
                    <label>
                        <input type="radio" value="si" v-model="decUno"> Sí
                    </label>  &nbsp; &nbsp;
                    <label>
                        <input type="radio" value="no" v-model="decUno"> No
                    </label>
                <p class="text-left mt-4">
                    4. Los recursos que poseo provienen de las actividades anteriormente descrita.
                </p>
                    <label>
                        <input type="radio" value="si" v-model="decUno"> Sí
                    </label>  &nbsp; &nbsp;
                    <label>
                        <input type="radio" value="no" v-model="decUno"> No
                    </label>
                <p class="text-left mt-4">
                    5. Entiendo y acepto que CLINICA VIDA FUNDACIÓN pueda proceder a la cancelación del contrato celebrado por el incumplimiento de lo anteriormente descrito y/o por
                    la información erronea, falsa o inexacta que yo haya proporcionado en este documento.
                </p>
                    <label>
                        <input type="radio" value="si" v-model="decUno"> Sí
                    </label>  &nbsp; &nbsp;
                    <label>
                        <input type="radio" value="no" v-model="decUno"> No
                    </label>
                    <b-button type="submit" id="login-btn">{{ labels.login }}</b-button>
            </div>
          </b-form-group>
          <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <b-container v-else class="pt-5">
      <b-col md="2" class="mx-auto">
        <div
          class="success-svg mb-4"
          :class="{ active: success }"
          v-if="!error"
        >
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 496 496"
            style="enable-background:new 0 0 496 496;"
            xml:space="preserve"
          >
            <path
              d="M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z
                     M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z"
              style="fill: #00ad7e"
            />
            <path
              d="M370.344,158.344L208,320.688l-82.344-82.344c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116
                    l88,88c3.124,3.123,8.188,3.123,11.312,0l168-168c3.07-3.178,2.982-8.242-0.196-11.312
                    C378.359,155.35,373.444,155.35,370.344,158.344z"
              style="fill: #00ad7e"
            />
          </svg>
        </div>
        <div class="success-svg mb-4" :class="{ active: error }" v-else>
          <svg
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 52 52"
            style="enable-background:new 0 0 52 52;"
            xml:space="preserve"
            sodipodi:docname="error.svg"
            inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
          >
            <metadata id="metadata43">
              <rdf:RDF
                ><cc:Work rdf:about=""
                  ><dc:format>image/svg+xml</dc:format
                  ><dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"/><dc:title></dc:title></cc:Work
              ></rdf:RDF>
            </metadata>
            <defs id="defs41" />
            <sodipodi:namedview
              pagecolor="#ffffff"
              bordercolor="#666666"
              borderopacity="1"
              objecttolerance="10"
              gridtolerance="10"
              guidetolerance="10"
              inkscape:pageopacity="0"
              inkscape:pageshadow="2"
              inkscape:window-width="1920"
              inkscape:window-height="1013"
              id="namedview39"
              showgrid="false"
              inkscape:zoom="4.5384615"
              inkscape:cx="26"
              inkscape:cy="26"
              inkscape:window-x="-9"
              inkscape:window-y="-9"
              inkscape:window-maximized="1"
              inkscape:current-layer="Capa_1"
            />
            <g id="g6" style="fill:#ee6363;fill-opacity:0.94117647">
              <path
                d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26   S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"
                id="path2"
                style="fill-opacity:0.94117647"
              />
              <path
                d="M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0   s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36   s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293   c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z"
                id="path4"
                style="fill-opacity:0.94117647"
              />
            </g>
            <g id="g8"></g>
            <g id="g10"></g>
            <g id="g12"></g>
            <g id="g14"></g>
            <g id="g16"></g>
            <g id="g18"></g>
            <g id="g20"></g>
            <g id="g22"></g>
            <g id="g24"></g>
            <g id="g26"></g>
            <g id="g28"></g>
            <g id="g30"></g>
            <g id="g32"></g>
            <g id="g34"></g>
            <g id="g36"></g>
          </svg>
        </div>
      </b-col>
      <b-col md="8" class="mx-auto justify-content-around">
        <h4 v-if="errorMessage">{{ labels.error }}</h4>
        <span
          type="button"
          id="reset-btn"
          v-if="success"
          @click="resetForm()"
          >{{ labels.new }}</span
        >
        <span type="button" id="check-btn" v-if="error" @click="checkForm()">{{
          labels.validate
        }}</span>
        <span type="button" id="resend-btn" v-if="error" @click="onSubmit()">{{
          labels.try
        }}</span>
      </b-col>
    </b-container>
  </div>
</template>

<script>
export default {
    name : 'ValidarProveedor',
    data : () => ({
        showPersonaNatural : false,
        showPersonaJuridica : false,
        showDeclaracion : false,
        datePickerFormat: "DD/MM/YYYY",
        form: {
            tipovinculacion: "",
            date: "",
            primerApellido: "",
            segundoApellido: "",
            nombre: "",
            identificacion: "",
            nroIdentNat: "",
            dateIssue: "",
            placeIssue: "",
            dateBirthdate: "",
            nationality: "",
            occupation: "",
            profession: "",
            econoActi: "",
            direccion: "",
            ciudad: "",
            telefono: "",
            email: "",
            ingresosMensuales: "",
            egresosMensuales: "",
            activos: "",
            pasivos: "",
            otrosIngresos: "",
            conceptoOtrIngresos: "",
            juridica: {
                razonSocial: "",
                representanteLegal: "",
                identificacion: "",
                nroIdentJur: "",
                placeIssue: "",
                dateIssue: "",
                direccionOfi: "",
                ciudadOfi: "",
                telefonoOfi: "",
                faxOfi: "",
                direccionSuc: "",
                ciudadSuc: "",
                telefonoSuc: "",
                faxSuc: "",
            },
            decUno: null,
        },
        companies: [],
        isLoading: false,
        success: false,
        error: false,
        errorMessage: false,
        myValue:"Seleccione...",
        myOptions: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "FORMULARIO DE CONOCIMIENTO SARLAFT",
                    subtitle: "Instrucciones",
                    instructive: [
                        "Bienvenidos a la plataforma para la visualización de proveedores, lo invitamos a revisar la información de cada uno.",
                    ],
                    // info: "Información de Proveedores",

                    greeting: "Crea un Usuario",
                    info: "Diligencie los datos",
                    nombre: "Nombre",
                    primerApellido: "Primer apellido",
                    segundoApellido: "Segundo apellido",
                    identificacion: "Identificación",
                    nroIdentNat: "Número",
                    dateIssue: "Fecha expedición",
                    placeIssue: "Lugar expedición",
                    dateBirthdate: "Fecha de nacimiento",
                    nationality: "Nacionalidad",
                    occupation: "Ocupación",
                    profession: "Profesión",
                    econoActi: "Actividad económica",
                    direccion: "Dirección",
                    direccionOfi: "Dirección oficina",
                    direccionSuc: "Dirección sucursal",
                    ciudad: "Ciudad",
                    ciudadOfi: "Ciudad oficina",
                    ciudadSuc: "Ciudad sucursal",
                    telefono: "Teléfono",
                    telefonoOfi: "Teléfono oficina",
                    telefonoSuc: "Teléfono sucursal",
                    email: "Correo electrónico",
                    ingresosMensuales: "$ Ingresos mensuales",
                    egresosMensuales: "$ Egresos mensuales",
                    activos: "$ Activos",
                    pasivos: "$ Pasivos",
                    otrosIngresos: "$ Otros ingresos",
                    conceptoOtrIngresos: "Concepto otros ingresos",
                    razonSocial: "Razón social",
                    representanteLegal: "Representante legal",
                    nroIdentJur: "Número",
                    password: "Contraseña",
                    phone: "Celular",
                    idNumber: "Documento de identidad",
                    role: "Rol del usuario",
                    language: "Idioma de la invitación",
                    login: "Crear",
                    new: "Crear un nuevo usuario",
                    try: "volver a intentar",
                    validate: "Validar el formulario",
                    error: "El usuario ya se encuentra inscrito",
                    tipovinculacion : 'Tipo vinculación',
                    date : 'Fecha diligenciamiento',
                    titleTipoPers : 'Tipo persona',
                    btnNatural : 'Natural',
                    btnJuridica : 'Jurídica'
                };
            } else {
                return {
                    title: "SARLAFT KNOWLEDGE FORM",
                    subtitle: "Instructions",
                    instructive: [
                        "Welcome to the providers visualization platform. Please check the information for each one",
                    ],
                    // info: "Providers Information",

                    greeting: "Let's Create a New User",
                    info: "Fill the fields",
                    nombre: "Name",
                    primerApellido: "First surname",
                    segundoApellido: "Second surname",
                    identificacion: "Identification",
                    nroIdentNat: "Number",
                    dateIssue: "Date of issue",
                    placeIssue: "Expedition location",
                    dateBirthdate: "Fecha de nacimiento",
                    nationality: "Nationality",
                    occupation: "Occupation",
                    profession: "Profession",
                    econoActi: "Economic activity",
                    direccion: "Address",
                    direccionOfi: "Office address",
                    direccionSuc: "Branch address",
                    ciudad: "City",
                    ciudadOfi: "Address city",
                    ciudadSuc: "Branch city",
                    telefono: "Phone",
                    telefonoOfi: "Address phone",
                    telefonoSuc: "Branch phone",
                    email: "Email address",
                    ingresosMensuales: "$ Monthly income",
                    egresosMensuales: "$ Monthly expenses",
                    activos: "$ Assets",
                    pasivos: "$ Passive",
                    otrosIngresos: "$ Other income",
                    conceptoOtrIngresos: "Other income concept",
                    razonSocial: "Company name",
                    representanteLegal: "Legal Representative",
                    nroIdentJur: "Number",
                    password: "Password",
                    phone: "Phone number",
                    idNumber: "Identification Number",
                    role: "User Role",
                    language: "Invite Email Language",
                    login: "Create",
                    new: "Create a new user",
                    try: "try again",
                    validate: "validate form",
                    error: "This user is already in the system",
                    tipovinculacion : 'Linkage type',
                    date : 'Date of completion',
                    titleTipoPers : 'Person type',
                    btnNatural : 'Natural',
                    btnJuridica : 'Jurídica'
                };
            }
        },
    },
    methods:{
        tpNatural(){
            // console.log('tpNatural');
            this.showDeclaracion = true
            this.showPersonaNatural = true
            this.showPersonaJuridica = false
        },
        tpJuridica(){
            // console.log('tpJuridica');
            this.showDeclaracion = true
            this.showPersonaJuridica = true
            this.showPersonaNatural = false
        }
    },
    mounted(){

    }
}
</script>

<style>

</style>